"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var SpinnerLoadWrapper = function SpinnerLoadWrapper(_ref) {
  var isLoading = _ref.isLoading,
      children = _ref.children,
      use = _ref.use,
      props = (0, _objectWithoutProperties2.default)(_ref, ["isLoading", "children", "use"]);

  if (isLoading) {
    return _react.default.createElement(_UILoadingSpinner.default, (0, _extends2.default)({}, props, {
      grow: true,
      showLabel: true,
      use: use
    }));
  }

  return children;
};

SpinnerLoadWrapper.propTypes = {
  children: _propTypes.default.node,
  isLoading: _propTypes.default.bool
};
SpinnerLoadWrapper.defaultProps = {
  isLoading: false,
  use: 'link'
};
var _default = SpinnerLoadWrapper;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/loading/SpinnerLoadWrapper.js
// module id = 337
// module chunks = 5 6